import React from 'react';
import { IconX, IconShoppingBag, IconTrash } from '@tabler/icons-react';
import { useCart } from '../../../contexts/CartContext';

const Cart = ({ isOpen, onClose }) => {
  const { checkout, removeItem, updateItem, loading } = useCart();

  const lineItems = checkout?.lines?.edges || [];
  const subtotal = checkout?.cost?.subtotalAmount?.amount || 0;
  const currency = checkout?.cost?.subtotalAmount?.currencyCode || 'USD';

  const handleCheckout = () => {
    if (checkout?.checkoutUrl) {
      window.open(checkout.checkoutUrl, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <>
      <div className={`ub-cart-overlay ${isOpen ? 'ub-active' : ''}`} onClick={onClose} />
      <div className={`ub-cart-sidebar ${isOpen ? 'ub-open' : ''}`}>
        <div className="ub-cart-header">
          <div className="ub-cart-title-wrapper">
            <IconShoppingBag size={24} strokeWidth={2} />
            <h2 className="ub-cart-title">Your Cart</h2>
          </div>
          <button onClick={onClose} className="ub-cart-close" aria-label="Close cart">
            <IconX size={24} strokeWidth={2} />
          </button>
        </div>

        <div className="ub-cart-content">
          {lineItems.length === 0 ? (
            <div className="ub-cart-empty">
              <IconShoppingBag size={64} color="#c41e3a" strokeWidth={1.5} />
              <p>Your cart is empty</p>
            </div>
          ) : (
            <>
              <div className="ub-cart-items">
                {lineItems.map(({ node: item }) => (
                  <div key={item.id} className="ub-cart-item">
                    {item.merchandise.image && (
                      <img
                        src={item.merchandise.image.url}
                        alt={item.merchandise.product.title}
                        className="ub-cart-item-image"
                      />
                    )}
                    <div className="ub-cart-item-details">
                      <h3 className="ub-cart-item-title">{item.merchandise.product.title}</h3>
                      {item.merchandise.title !== 'Default Title' && (
                        <p className="ub-cart-item-variant">{item.merchandise.title}</p>
                      )}
                      <div className="ub-cart-item-footer">
                        <div className="ub-cart-item-quantity">
                          <button
                            onClick={() => updateItem(item.id, Math.max(0, item.quantity - 1))}
                            className="ub-quantity-btn"
                            disabled={loading}
                          >
                            -
                          </button>
                          <span>{item.quantity}</span>
                          <button
                            onClick={() => updateItem(item.id, item.quantity + 1)}
                            className="ub-quantity-btn"
                            disabled={loading}
                          >
                            +
                          </button>
                        </div>
                        <div className="ub-cart-item-price">
                          ${parseFloat(item.merchandise.priceV2.amount).toFixed(2)}
                        </div>
                      </div>
                    </div>
                    <button
                      onClick={() => removeItem(item.id)}
                      className="ub-cart-item-remove"
                      aria-label="Remove item"
                      disabled={loading}
                    >
                      <IconTrash size={20} strokeWidth={2} />
                    </button>
                  </div>
                ))}
              </div>

              <div className="ub-cart-footer">
                <div className="ub-cart-subtotal">
                  <span>Subtotal:</span>
                  <span className="ub-cart-subtotal-amount">
                    {currency} ${parseFloat(subtotal).toFixed(2)}
                  </span>
                </div>
                <button
                  onClick={handleCheckout}
                  className="ub-checkout-btn"
                  disabled={loading}
                >
                  Proceed to Checkout
                </button>
                <p className="ub-cart-notice">
                  Taxes and shipping calculated at checkout
                </p>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Cart;
